import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";

@Injectable()
export class PersonTypeService {
	constructor(private httpclientService: HttpclientService) {}
	loadPERSONTYPEList(applicationItemID, schoolID) {
		var postResult$ = new Subject();
		var url = "Report/PERSONTYPEGetList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
